import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchContractRequests,
  RejectContract,
  AcceptContract,
  fetchSignedContracts,
  DeleteContract,
  deleteApprovedContract,
} from "store/actions/ContractRequestsAction";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import Tabs from "components/Tabe";
import TableComponent from "components/TableComponent";
import moment from "moment";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const ContractRequests = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const sanitizedType = type
    ? type.replace(/^['"]|['"]$/g, "")
    : "pendingRequests";
  const [activeTab, setActiveTab] = useState(sanitizedType);
  const [deleteModal, setDeleteModal] = useState(false);
  const [acceptModal, setAcceptModal] = useState(false);
  const [rowId, setRowId] = useState();
  const [acceptLoader, setAcceptLoader] = useState(null);
  const [deleteLoader, setDeleteLoader] = useState(null);
  const [acceptingContract, setAcceptingContract] = useState(false);
  const {
    ContractRequests,
    SignedContracts,
    loadingContracts,
    loadingSignedContracts,
    loadingApprovedContracts,
  } = useSelector((state) => state.ContractRequest);

  const infoPoints = [
    "The admin manages three tabs: Pending Requests, Signed Requests, and Approved Requests. From here, the admin can review and either accept or reject fan requests",
  ];
  const subPoints = [
    {
      title: "Pending Requests",
      description:
        "Admin can review the fan request for the institue and take action e.g. accept or reject the contract request",
    },
    {
      title: "Signed Requests",
      description:
        "After the admin accepting the contract. fan need to fill data in the aggrement after admin will review it and do put his data in the fields. Also admin can delete the contract requests from ths signed requests tab.",
    },
    {
      title: "Approved Requests",
      description: "Admin can review all the approved fan contract.",
    },
  ];

  const infoTitle = "Contract Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    dispatch(fetchContractRequests());
  }, []);
  useEffect(() => {
    dispatch(fetchSignedContracts());
  }, []);

  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const acceptToggle = () => {
    setAcceptModal(!acceptModal);
  };

  const handleAcceptContract = () => {
    if (!rowId.id) return;
    setAcceptLoader(rowId);
    dispatch(AcceptContract(rowId.id, rowId))
      .then(() => {
        setAcceptModal(false);
      })
      .finally(() => {
        setAcceptLoader(null);
      });
  };

  const handleSigned = async () => {
    try {
      setDeleteLoader(rowId);
      await dispatch(DeleteContract(rowId));
      deleteToggle();
    } finally {
      setTimeout(() => setDeleteLoader(null), 700);
    }
  };

  const handleApproved = async () => {
    try {
      setDeleteLoader(rowId);
      await dispatch(deleteApprovedContract(rowId));
      deleteToggle();
    } finally {
      setTimeout(() => setDeleteLoader(null), 700);
    }
  };

  const handleDeleteModal = async () => {
    try {
      setDeleteLoader(rowId);
      await dispatch(RejectContract(rowId));
      setDeleteModal(false);
    } finally {
      setTimeout(() => setDeleteLoader(null), 700);
    }
  };

  const columns = ["Email", "Photo ID", "Date of Request"];
  const columnSigned = ["Email", "Photo ID", "Date of Acceptance"];
  const columnApprove = ["Email", "Photo ID", "Approval Date"];
  const keyMap = {
    Email: "email",
    "Photo ID": "img",
    "Date of Request": "formattedCreatedAt",
    "Date of Acceptance": "formattedAcceptance",
    "Approval Date": "formattedApprove",
  };

  const formatEarningsData = (data, status) => {
    return data
      .filter((item) => item.status === status)
      .map((item) => ({
        ...item,
        formattedCreatedAt: moment
          .unix(item?.createdAT?.seconds)
          .format("MM-DD-YYYY"),
        formattedAcceptance: moment
          .unix(item?.acceptedAt?.seconds)
          .format("MM-DD-YYYY"),
        formattedApprove: moment
          .unix(item?.approvedAT?.seconds)
          .format("MM-DD-YYYY"),
        img: <img src={item.imageURL} width={100} alt="" />,
      }));
  };

  const renderActions = (row) =>
    row.status === "pending" ? (
      <>
        <Button
          size="sm"
          className="bg-primary border-0 text-white"
          onClick={() => {
            setRowId(row);
            acceptToggle();
          }}
          disabled={acceptingContract}
        >
          Accept
        </Button>
        <Button
          size="sm"
          className="bg-danger border-0 text-white"
          onClick={() => {
            setRowId(row.id);
            deleteToggle();
          }}
        >
          Reject
        </Button>
      </>
    ) : row.status === "signed" ? (
      <>
        <Link to={`contract-request/${row.id}`}>
          <Button size="sm" className="text-secondary border-0 text-white">
            <i class="fas fa-solid fa-eye text-dark"></i>
          </Button>
        </Link>
        <Button
          size="sm"
          className="bg-danger border-0 text-white ml-2"
          onClick={() => {
            deleteToggle();
            setRowId(row.id);
          }}
        >
          Delete
        </Button>
      </>
    ) : row.status === "approved" ? (
      <>
        <Link to={`contract-request/${row.id}`}>
          <Button size="sm" className="text-secondary border-0 text-white">
            <i class="fas fa-solid fa-eye text-dark"></i>
          </Button>
        </Link>
        <Button
          size="sm"
          className="bg-danger border-0 text-white ml-2"
          onClick={() => {
            deleteToggle();
            setRowId(row.id);
          }}
        >
          Delete
        </Button>
      </>
    ) : null;

  const tabs = [
    {
      id: "pendingRequests",
      title: "Pending Requests",
      content: (
        <>
          {loadingContracts ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner color="primary" size="md" />
            </div>
          ) : (
            <TableComponent
              columns={columns}
              data={formatEarningsData(ContractRequests, "pending")}
              keyMap={keyMap}
              renderActions={renderActions}
            />
          )}
        </>
      ),
      onClick: () => {},
    },
    {
      id: "signedRequests",
      title: "Signed Requests",
      content: (
        <>
          {loadingSignedContracts ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner color="primary" size="md" />
            </div>
          ) : (
            <TableComponent
              columns={columnSigned}
              data={formatEarningsData(SignedContracts, "signed")}
              keyMap={keyMap}
              renderActions={renderActions}
            />
          )}
        </>
      ),
      onClick: () => {},
    },
    {
      id: "approvedRequests",
      title: "Approved Requests",
      content: (
        <>
          {loadingApprovedContracts ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner color="primary" size="md" />
            </div>
          ) : (
            <TableComponent
              columns={columnApprove}
              data={formatEarningsData(SignedContracts, "approved")}
              keyMap={keyMap}
              renderActions={renderActions}
            />
          )}
        </>
      ),
      onClick: () => {},
    },
  ];
  return (
    <>
      <Header />
      <Container className="mt-2" fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Row>
          <div className="col">
            <Card className="shadow">
              <Tabs activeTab={activeTab} toggleTab={toggleTab} tabs={tabs} />
            </Card>
          </div>
        </Row>
        <TabsInfoModal
          setInfoModalOpen={setInfoModalOpen}
          infoModalOpen={infoModalOpen}
          data={infoPoints}
          title={infoTitle}
          subPoints={subPoints}
        />
        <Modal isOpen={deleteModal} centered>
          <ModalBody>
            <div className="text-center">
              <p className="mt-3" style={{ fontSize: 24 }}>
                Are you sure?
              </p>
              <p style={{ fontSize: 16 }}>You want to delete this request??</p>
              <Button
                color="primary"
                onClick={() => setDeleteModal(false)}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                color="danger"
                onClick={() => {
                  if (activeTab === "pendingRequests") {
                    handleDeleteModal();
                  } else if (activeTab === "signedRequests") {
                    handleSigned();
                  } else if (activeTab === "approvedRequests") {
                    handleApproved();
                  }
                }}
                disabled={deleteLoader === rowId}
              >
                {deleteLoader === rowId ? <Spinner size="sm" /> : "Delete"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={acceptModal} centered>
          <ModalBody>
            <div className="text-center">
              <p className="mt-3" style={{ fontSize: 24 }}>
                Are you sure?
              </p>
              <p style={{ fontSize: 16 }}>You want to accept this request??</p>
              <Button
                color="danger"
                onClick={() => setAcceptModal(false)}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                color="primary"
                onClick={handleAcceptContract}
                disabled={acceptLoader === rowId}
              >
                {acceptLoader === rowId ? <Spinner size="sm" /> : "Accept"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default ContractRequests;
